<template translate="no">

  <v-container>

    <!-- Adicione o diálogo para a sugestão SUGESTAO DE QUESTAO -->
      <v-dialog v-model="showSuggestionDialog" max-width="500">
        <v-card>
          <v-card-title>Escreva sua sugestão</v-card-title>
          <v-card-text class="text-justify">
            <!-- Adicione a caixa de texto para a sugestão -->
            Se você encontrou algum problema nessa questão ou gostaria de sugerir alguma mudança, ficaríamos muito agradecidos por seu feedback.
            <v-textarea v-model="suggestionText" label="Caixa de Sugestão" rows="5" :rules="[v => !!v || 'Campo obrigatório']"></v-textarea>
          </v-card-text>
          <v-card-actions>
            <!-- Botão Salvar sempre visível, mas desabilitado quando o texto está vazio -->
            <v-btn 
              @click="saveSuggestion" 
              color="primary" 
              text 
              class="ml-auto" 
              :disabled="suggestionText === ''"
            >
              Salvar
            </v-btn>
            <v-btn @click="closeSuggestionDialog" color="red" text>Fechar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
     <!-- Novo Diálogo para a redefinição -->
      <v-dialog v-model="resetting" max-width="400" persistent>
        <v-card elevation="12" class="text-center" color="white" style="border-radius: 16px;">
          <v-card-text class="pa-8">
            <v-progress-circular indeterminate color="primary" size="48" class="mb-6"></v-progress-circular>
            <div class="loading-title font-weight-bold text-h6 mb-4" style="color: #315fd8; font-family: 'Roboto Condensed', sans-serif;">
              Salvando...
            </div>
            <div class="loading-text text-body-2" style="color: #666; line-height: 1.6;">
              <p class="mb-2">Aguarde. Suas métricas estão sendo salvas.</p>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog> 

     <!-- Dialog Comment with Video -->
      <v-dialog v-model="showCommentDrawer" max-width="800" persistent>
        <v-card>
          <v-card-title class="headline">Resolução</v-card-title>
          <v-card-text>
            <!-- Questão - Toggle -->
            <div class="mb-4">
              <v-btn 
                small 
                @click="showQuestionDetails = !showQuestionDetails"
                color="primary"
                text
              >
                <v-icon small class="mr-2">{{ showQuestionDetails ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                {{ showQuestionDetails ? 'Ocultar' : 'Mostrar' }} Questão
              </v-btn>
            </div>

            <v-expand-transition>
              <div v-if="showQuestionDetails" class="mb-4 pa-3 grey lighten-4" style="border-radius: 4px;">
                <div class="text-body-1 html-content" v-html="formatHTMLContent(currentQuestion.question)"></div>
                <div v-if="currentQuestion.questionImage" class="d-flex justify-center mt-3 mb-3">
                  <img :src="currentQuestion.questionImage" alt="Question Image" style="max-width: 100%; max-height: 300px;" />
                </div>
                <div class="mt-3">
                  <strong>Opções:</strong>
                  <v-list dense>
                    <v-list-item 
                      v-for="(option, idx) in currentQuestion.questionOptions" 
                      :key="idx"
                      :class="{ 'green--text font-weight-bold': option.trim() === currentQuestion.questionAnswer.trim(), 'orange--text': option.trim() === currentAnswer.trim() && option.trim() !== currentQuestion.questionAnswer.trim() }"
                    >
                      <v-list-item-content style="display: flex; flex-direction: row; align-items: center; flex-wrap: wrap;">
                        <div class="html-content" v-html="formatHTMLContent(option)" style="flex: 1;"></div>
                        <span v-if="option && currentAnswer && option.trim() === currentAnswer.trim()" class="ml-2">👉 (sua resposta)</span>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </div>
              </div>
            </v-expand-transition>

            <!-- Resolução - Toggle -->
            <div class="mb-4 mt-4">
              <v-btn 
                small 
                @click="showAnswerDetails = !showAnswerDetails"
                color="success"
                text
              >
                <v-icon small class="mr-2">{{ showAnswerDetails ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                {{ showAnswerDetails ? 'Ocultar' : 'Mostrar' }} Resolução
              </v-btn>
            </div>

            <v-expand-transition>
              <div v-if="showAnswerDetails">
                <div v-if="currentAnswer !== null" class="mb-4">
                  <strong>Sua Resposta:</strong>
                  <p>{{ currentAnswer }}</p>
                </div>
                <div v-if="currentQuestion.questionAnswer !== null" class="mb-4">
                  <strong>Resposta Correta:</strong>
                  <p><strong class="green--text text--darken-2">{{ currentQuestion.questionAnswer }}</strong></p>
                </div>
                <div v-if="currentQuestion.questionComment !== null" class="mb-4">
                  <strong>Comentário:</strong>
                  <!-- <p>{{ currentQuestion.questionComment || 'Estamos elaborando a resolução. Em breve, você poderá encontrá-la aqui.' }}</p> -->
                  <div class="html-content mt-2" v-html="formatComment(currentQuestion.questionComment)"></div>
                </div>
                <div v-if="currentQuestion.questionVideo" class="mb-4">
                  <strong>Confira:</strong>
                  <v-responsive>
                    <iframe width="100%" height="315" :src="currentQuestion.questionVideo" frameborder="0" allowfullscreen></iframe>
                  </v-responsive>
                </div>
              </div>
            </v-expand-transition>
          </v-card-text>
          <v-card-actions class="d-flex justify-end">
            <v-btn color="red" text @click="showCommentDrawer = false">Fechar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>


    <!-- Questions-->
    <v-card v-if="currentQuestion !== null" class="question-card" :key="'question-'+currentQuestionIndex">
      <v-card-title class="headline font-weight-bold">Questão {{ currentQuestionIndex + 1 }} {{ isReview ? '(Revisão)' : '' }}
            <v-btn icon @click="openSuggestionDialog" class="ml-auto mb-3" style="
                padding: 4px;
                border-radius: 4px;
                max-width: 30px;
                max-height: 30px;
                background-color: rgba(255, 0, 0, 0.1);
              ">
              <v-icon color="red" >mdi-flag</v-icon>
            </v-btn>  
      </v-card-title>
      <v-chip  class="ml-5" color="teal" style="color: white; margin-right: 5px; padding-left: 10px;  border-radius: 8px;">{{ currentQuestion.questionTheme }}</v-chip>
      <v-chip class="ml-5" color="cyan " style="color: white; border-radius: 8px;" >{{ currentQuestion.questionSubTheme }}</v-chip>
      <v-card-text class="text-justify">
        <v-container>
          <v-row>
            <v-col cols="12">
              <div class="question-container" translate="no">
                <div class="question-text">
                  <div class="text-body-1 mb-4 html-content" v-html="formatHTMLContent(currentQuestion.question)"></div>
                  <v-col cols="12" class="d-flex justify-center" > 
                    <div v-if="currentQuestion.questionImage" class="image-container">
                      <img :src="currentQuestion.questionImage" alt="Question Image" class="question-image" />
                    </div>
                  </v-col>
                  <v-radio-group 
                    v-model="currentAnswer" 
                    :mandatory="true"
                    :key="'question-' + currentQuestionIndex" 
                    translate="no"
                  >                    <v-radio
                    v-for="(option, optionIndex) in currentQuestion.questionOptions"
                    :key="'q'+currentQuestionIndex+'o'+optionIndex"
                    :value="option"
                    :disabled="questionLocked"
                    :class="{
                      'green-outline': isCorrectOption(option) && questionLocked && selectedMode === 'Tutor',
                      'red-outline': isWrongOption(option) && questionLocked && selectedMode === 'Tutor'
                    }"
                    >
                      <template v-slot:label>
                        <div class="html-content text-body-1" v-html="formatHTMLContent(option)"></div>
                      </template>
                    </v-radio>
                  </v-radio-group>             
                </div>                
              </div>
            </v-col>
          </v-row>
        </v-container>
        <v-card-actions>
          <v-btn @click="goToPreviousQuestion" color="primary" v-if="currentQuestionIndex > 0">
            <span class="hidden-sm-and-up">&lt;</span> <!-- Displays "<" on smaller screens -->
            <span class="hidden-xs-only">Anterior</span> <!-- Displays "Anterior" on larger screens -->
          </v-btn>
          <v-btn class="ml-auto" @click="confirmQuestion" color="green" dark :disabled="currentAnswer === '' || currentAnswer === null" v-if="!questionLocked">
            Confirmar
          </v-btn>
          <v-btn @click="showCommentDrawer = true" color="secondary" v-if="questionLocked && selectedMode === 'Tutor'">
            Resolução
          </v-btn>
          <v-btn v-if="questionLocked" class="ml-auto" @click="quizCompleted ? resetTest() : (currentQuestionIndex + 1 === questions.length ? confirmLastQuestion() : nextQuestion())" color="primary" >
            <span class="hidden-sm-and-up">></span>
            <span class="hidden-xs-only">{{ quizCompleted ? 'Encerrar' : (currentQuestionIndex + 1 === questions.length ? 'Finalizar' : 'Avançar') }}</span>
          </v-btn>  
        </v-card-actions>
      </v-card-text>
        <!-- Progress Bar -->
        <v-row>
          <v-col cols="12">
            <v-progress-linear
              :value="calculateProgressPercentage"
              height="10"
              color="primary"
              background-color="grey lighten-3"
            ></v-progress-linear>
            <div class="text-center mt-2">{{ currentQuestionIndex + 1 }} de {{ questions.length }}</div>
          </v-col>
        </v-row>
    </v-card>
<!-- Questions dialog finish-->
<v-dialog v-if="quizCompleted" v-model="dialog" max-width="500" persistent style="z-index: 1000;">
  <v-card>
    <v-card-title class="headline">Resultados</v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="12">
            <v-alert :value="true" type="success" outlined>
              Respostas Corretas: {{ totalCorrectItems }}
            </v-alert>
            <v-alert :value="true" type="error" outlined>
              Respostas Incorretas: {{ totalAnsweredQuestions - totalCorrectItems }}
            </v-alert>
            <v-alert :value="true" type="info" outlined>
              Total de Questões Respondidas: {{ totalAnsweredQuestions }}
            </v-alert>
          </v-col>
  
            <!-- Seção para exibir as estatísticas por tema -->
          <v-container v-if="Object.keys(themeStats).length > 0">
            <v-data-table :headers="tableHeaders" :items="getThemeStatsAsArray()" class="elevation-1" :mobile-breakpoint="0">
              <template v-slot:item="{ item }">
                <tr>
                  <td>{{ item.theme }}</td>
                  <td>{{ item.correctCount }}</td>
                  <td>{{ item.totalQuestions }}</td>
                </tr>
              </template>
              <template v-slot:no-data>
                <v-alert :value="true" color="info" outlined>
                  Nenhuma estatística disponível.
                </v-alert>
              </template>
            </v-data-table>
          </v-container>
  
          <v-col cols="6" class="d-flex justify-center">
            <v-progress-circular
                      :size="100"
                      :width="15"
                      :value= (totalCorrectItems/totalAnsweredQuestions)*100                    
                      color="success"
                      filled
                    >
                    <h3>{{((totalCorrectItems/totalAnsweredQuestions)*100).toFixed(1)}}%</h3>
                    <span style="
                        position: absolute;
                        bottom: -25px;
                        left: 50%;
                        transform: translateX(-50%);
                        font-size: 16px;
                        font-weight: bold;">
                      Acertos
                    </span>
              </v-progress-circular>                  
          </v-col>
  
          <v-col cols="6" class="d-flex justify-center">
            <v-progress-circular
                    :size="100"
                    :width="15"
                    :value= (incorrectCount/totalAnsweredQuestions)*100
                    color="red"
                    filled
                  >
                  <h3>{{((incorrectCount/totalAnsweredQuestions)*100).toFixed(1)}}%</h3>
                  <span style="
                      position: absolute;
                      bottom: -25px;
                      left: 50%;
                      transform: translateX(-50%);
                      font-size: 16px;
                      font-weight: bold;">
                    Erros
                  </span>
            </v-progress-circular>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  
    <v-card-actions class="d-flex justify-center">
      <v-btn color="primary" @click="resetTest">Encerrar</v-btn>
      <v-btn color="success" @click="seeTest">Visualizar Respostas</v-btn>
    </v-card-actions>
  
  </v-card>
</v-dialog>
    <div>
    <!-- Exibe os dados que foram passados -->
    <div v-if="quizData">
      <p>Modo: {{ quizData.mode }}</p>
      <p>Total de Questões: {{ quizData.items.length }}</p>
      <!-- Aqui você pode exibir as questões ou qualquer outro conteúdo -->
    </div>
  </div>
  </v-container>

  <CSATDialog
    v-model="showCSATDialog"
    @close="handleCSATClose"
    style="z-index: 2000;" 
  />

</template>

<script>
import CSATDialog from '@/components/CSATDialog.vue';

export default {
  components: {
    CSATDialog,
  },
  data() {
    return {
      quizData: null,
      selectedNumberOfQuestions: null, // Store the selected number of questions
        showCommentDrawer: false,
        showQuestionDetails: false,      // NOVO
        showAnswerDetails: true,        // NOVO
        questionLocked: false,
        quizStarted: false,
        selectedMode: 'Tutor',
        selectedTheme: ["Todos"],
        themeStats: {},
        currentQuestionIndex: 0,
        currentQuestion: null,
        currentAnswer: null,
        dialog: false,
        quizCompleted: false,
        quizstart: false,
        resetting: false,
        showSuggestionDialog: false,
        showQuestionResetDialog: false,
        suggestionText: '',
        completedQuestionIds: [], // Array para armazenar os IDs das questões completadas
        sentQuestionIds: [], // IDs já enviados para o backend
        showCSATDialog: false, // Controla a exibição do CSATDialog

    };
  },
  created() {
    if (this.$route.query.items) {
      this.quizData = {
        items: JSON.parse(this.$route.query.items), // Converte a string de volta para array
        mode: this.$route.query.mode,
      };
      this.isReview = this.$route.query.isReview === 'true'; // Define se é revisão
    }
    // Restante do código permanece o mesmo
    this.currentQuestion = this.quizData.items[0];
    this.answers = new Array(this.quizData.items.length);
    this.selectedMode = this.quizData.mode,
    this.questions = this.quizData.items,

    this.quizCompleted = false;
    this.dialog = false;
    this.currentQuestionIndex = 0;
    localStorage.removeItem('tempQuizData');
    sessionStorage.clear();
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then(regs => {
        regs.forEach(reg => reg.unregister());
      });
    }

},
  computed: {
      totalAnsweredQuestions() {
      let total = 0;
      for (const theme in this.themeStats) {
        total += this.themeStats[theme].totalQuestions;
      }
      return total;
    },
  
    totalCorrectItems() {
      let total = 0;
      for (const theme in this.themeStats) {
        total += this.themeStats[theme].correctCount;
      }
      return total;
    },
    loading() {
            return this.$store.getters.loading;
        },
       correctCount() {
        const filteredQuestions = this.quizData.items.filter((question) => {
          if (this.selectedTheme.length === 0 || this.selectedTheme.includes('Todos')) {
            // Se 'Todos' ou nenhum tema específico selecionado, inclua todas as questões
            return true;
          } else {
            // Verifica se a questão possui pelo menos um dos temas selecionados
            return this.selectedTheme.includes(question.questionTheme);
          }
        });

        const filteredAnswers = this.answers.slice(0, filteredQuestions.length);

        return filteredAnswers.filter((answer, index) => {
          const correctAnswer = filteredQuestions[index].questionAnswer;
          
          // Nova verificação segura com o trim()
          const isCorrect = answer && correctAnswer 
            ? answer.trim() === correctAnswer.trim() 
            : answer === correctAnswer;

          return isCorrect || (this.selectedTheme.length === 0 && answer === undefined);
        }).length;
      },
  
    incorrectCount() {
      const filteredQuestions = this.quizData.items.filter((question) => {
        if (this.selectedTheme.length === 0 || this.selectedTheme.includes('Todos')) {
          return true;
        } else {
          return this.selectedTheme.includes(question.questionTheme);
        }
      });

      const filteredAnswers = this.answers.slice(0, filteredQuestions.length);

      return filteredAnswers.filter((answer, index) => {
        const correctAnswer = filteredQuestions[index].questionAnswer;
        // Adicionamos a checagem segura com trim()
        const isWrong = answer && correctAnswer ? answer.trim() !== correctAnswer.trim() : answer !== correctAnswer;
        return isWrong && (this.selectedTheme.length !== 0 || answer !== undefined);
      }).length;
    },

    
      answeredQuestions() {
      return this.answers.filter(answer => answer !== undefined).length;
      },
    },

  methods: {

  formatComment(text) {
    if (!text) return 'Estamos elaborando a resolução. Em breve, você poderá encontrá-la aqui.';

    // Remove aspas duplas que possam estar em volta do link (como no seu exemplo: "https://...")
    let cleanText = text.replace(/"(https?:\/\/[^"]+\.(?:png|jpg|jpeg|gif|svg)(?:\?[^"]*)?)"/gi, '$1');

    // Identifica URLs de imagens (inclusive com os tokens do Firebase) e transforma em tag <img />
    const imageRegex = /(https?:\/\/[^\s<]+\.(?:png|jpg|jpeg|gif|svg)(?:\?[^\s<]*)?)/gi;
    
    cleanText = cleanText.replace(imageRegex, (url) => {
      return `<br><div class="d-flex justify-center my-4"><img src="${url}" alt="Imagem da resolução" style="max-width: 100%; max-height: 400px; border-radius: 8px; box-shadow: 0 2px 6px rgba(0,0,0,0.15);" /></div><br>`;
    });

    // Se o texto não contiver tags HTML (como <p>, <table>, etc.), converte as quebras de linha normais (\n) para <br>
    const hasHTML = /<[a-z][\s\S]*>/i.test(cleanText);
    if (!hasHTML) {
      cleanText = cleanText.replace(/\n/g, '<br>');
    }

    return cleanText;
  },
    confirmLastQuestion() {
      if (this.currentAnswer !== null) {
        this.answers.splice(this.currentQuestionIndex, 1, this.currentAnswer);
        this.questionLocked = true; // Lock the question
        this.quizCompleted = true;
        this.dialog = true; // Exibe o diálogo de resultados

        // Verifica se o CSATDialog já foi exibido
        if (!localStorage.getItem('csatDialogShown')) {
          // Obter a data atual
          const currentDate = new Date();

          // Obter a data de lastcsat do estado Vuex
          const lastCSATDate = this.$store.state.userName[0]?.lastcsat;
          const totalSinceCSAT = this.$store.state.userName[0]?.totalsincecsat || 0; // Obter totalsincecsat ou 0 se não existir
          console.log("dias:", lastCSATDate); // Debugging log
          console.log("totalsincecsat:", totalSinceCSAT); // Debugging log

          if (lastCSATDate) {
            // Converter a data de lastcsat para um objeto Date
            const lastCSAT = new Date(lastCSATDate.split('/').reverse().join('-'));

            // Calcular a diferença em dias
            const diffInDays = Math.floor((currentDate - lastCSAT) / (1000 * 60 * 60 * 24));
            console.log("Diferença em dias:", diffInDays); // Debugging log

            // Exibir o CSATDialog apenas se a diferença for de pelo menos 30 dias e totalsincecsat for maior que 50
            if (diffInDays >= 30 && totalSinceCSAT > 50) {
              this.showCSATDialog = true; // Exibe o CSATDialog
              localStorage.setItem('csatDialogShown', 'true'); // Marca que o CSATDialog foi exibido
            }
          } else {
            // Se não houver lastcsat, exibe o CSATDialog apenas se totalsincecsat for maior que 50
            if (totalSinceCSAT > 50) {
              this.showCSATDialog = true;
              localStorage.setItem('csatDialogShown', 'true');
            }
          }
        }
      }
    },

    async handleCSATClose(rating) {
      try {
        console.log("CSAT Rating Submission!:", rating); // Exibe o rating no console
        // Cria o payload para o dispatch
        const payload = {
          csat: rating,
          source: 'qbank',
        };

        // Faz o dispatch para o Vuex
        this.$store.dispatch('postCsat', payload)
          .then(() => {
            console.log("CSAT enviado com sucesso.");
          })
          .catch((error) => {
            console.error("Erro ao enviar CSAT:", error);
          });

        // Obter a data atual no formato desejado
        const currentDate = new Date();
        const formattedDate = `${currentDate.getDate()}/${currentDate.getMonth() + 1}/${currentDate.getFullYear()}`;

        // Chamar a ação saveProfile no Vuex com o campo lastcsat
        await this.$store.dispatch('saveProfile', { lastcsat: formattedDate });
        await this.$store.dispatch('saveProfile', { totalsincecsat: 999 });

        // Atualizar o campo lastcsat localmente no estado Vuex
        if (this.$store.state.userName[0]) {
          this.$store.state.userName[0].lastcsat = formattedDate;
        }

        console.log('Data salva com sucesso no campo lastcsat (online e local):', formattedDate);
      } catch (error) {
        console.error('Erro ao salvar a data no campo lastcsat:', error);
      } finally {
        // Fecha o CSATDialog
        this.showCSATDialog = false;

        // Certifique-se de que o diálogo de resultados permaneça aberto
        if (this.quizCompleted) {
          this.dialog = true;
        }
      }
    },

    seeTest() {
      console.log("clicando...");
      this.quizCompleted = false;
      this.selectedMode = 'Tutor';
      this.dialog = false;

      // O CSATDialog não será exibido novamente porque está controlado pelo localStorage
    },
      clearCookies() {
        const cookies = document.cookie.split(";");
        
        for (let i = 0; i < cookies.length; i++) {
          const cookie = cookies[i];
          const eqPos = cookie.indexOf("=");
          const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
          document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
        }
  
        console.log("Cookies limpos!");
      },
  
      clearLocalStorage() {
        localStorage.clear();
        sessionStorage.clear();
        console.log("LocalStorage e SessionStorage limpos!");
      },
      openSuggestionDialog() {
        // Abre o diálogo de sugestão
        this.showSuggestionDialog = true;
      },
      openQuestionResetDialog() {
        // Abre o diálogo de sugestão
        this.showQuestionResetDialog = true;
      },
      saveQuestionReset() {
        this.resetting = true; 
        // Lógica para salvar as edições (ex.: enviar para a API, atualizar o Vuex, etc.)
        this.$store.dispatch('saveQuestionReset')
          .then(() => {
            // Aguardar um tempo antes de recarregar os itens
            setTimeout(() => {
              this.$store.dispatch("loadItems");
            }, 3000); // 500 milissegundos de delay
            setTimeout(() => {
              this.resetting = false;
            }, 8000); // 500 milissegundos de delay
          })
          .catch(error => {
            console.error("Erro ao salvar item:", error);
          });
        this.closeSuggestionDialog();
      },
      saveSuggestion() {
        // Implemente a lógica para salvar a sugestão, juntamente com as informações da questão atual
        // Pode incluir o envio para um servidor, armazenamento local, etc.
          const postSuggestion = {
            suggestionQuestion: this.currentQuestion.question,
            suggestionText: this.suggestionText
          };
          console.log(postSuggestion)
          this.$store.dispatch('postSuggestion', postSuggestion)
            .then(() => {
              console.log("Suggestion successful.");
              // Reload the window after successful submission
              setTimeout(() => {
                this.closeSuggestionDialog();
              }, 1000); // 2000 milliseconds = 2 seconds
            })
            .catch((error) => {
              console.error("Error submitting data:", error);
              // Handle error scenario here if needed
            });
     
      },
      closeSuggestionDialog() {
        // Fecha o diálogo de sugestão
        this.showSuggestionDialog = false;
        this.showQuestionResetDialog = false;
        // Limpa o texto da sugestão
        this.suggestionText = '';
      },
      getThemeStatsAsArray() {
      return Object.entries(this.themeStats).map(([theme, stats]) => ({
        theme,
        correctCount: stats.correctCount,
        totalQuestions: stats.totalQuestions,
      }));
      },  
    
      handleThemeSelectionChange() {
        // Se "Todos" estiver selecionado e qualquer outra opção for selecionada, desmarca "Todos"
        if (this.selectedTheme.includes('Todos') && this.selectedTheme.length > 1) {
          const todosIndex = this.selectedTheme.indexOf('Todos');
          this.selectedTheme.splice(todosIndex, 1);
        } 
        // Se todas as opções forem desmarcadas, seleciona "Todos"
        else if (this.selectedTheme.length === 0) {
          this.selectedTheme = ['Todos'];
        }
        
      },
    
      confirmTabChange(to, from, next) {
        if (this.quizStarted && from.path === '/webapp/home' && to.path !== '/webapp/home') {
          this.$refs.confirmDialog.showConfirmation(() => {
            // If confirmed, navigate to the requested route
            next();
          });
        } else {
          next(); // Continue with the route change if conditions aren't met
        }
      },
  
      confirmLastQuestion() {
        if (this.currentAnswer !== null) {
          this.answers.splice(this.currentQuestionIndex, 1, this.currentAnswer);
          this.questionLocked = true; // Lock the question
          this.quizCompleted = true;
          this.dialog = true; // Exibe o diálogo de resultados

          // Verifica se o CSATDialog já foi exibido
          if (!localStorage.getItem('csatDialogShown')) {
            // Obter a data atual
            const currentDate = new Date();

            // Obter a data de lastcsat do estado Vuex
            const lastCSATDate = this.$store.state.userName[0]?.lastcsat;
            const totalSinceCSAT = this.$store.state.userName[0]?.totalsincecsat || 0; // Obter totalsincecsat ou 0 se não existir

            if (lastCSATDate) {
              // Converter a data de lastcsat para um objeto Date
              const lastCSAT = new Date(lastCSATDate.split('/').reverse().join('-'));

              // Calcular a diferença em dias
              const diffInDays = Math.floor((currentDate - lastCSAT) / (1000 * 60 * 60 * 24));

              // Exibir o CSATDialog apenas se a diferença for de pelo menos 30 dias e totalsincecsat for maior que 50
              if (diffInDays >= 30 && totalSinceCSAT > 50) {
                this.showCSATDialog = true; // Exibe o CSATDialog
                localStorage.setItem('csatDialogShown', 'true'); // Marca que o CSATDialog foi exibido
              }
            } else {
              // Se não houver lastcsat, exibe o CSATDialog apenas se totalsincecsat for maior que 50
              if (totalSinceCSAT > 50) {
                this.showCSATDialog = true;
                localStorage.setItem('csatDialogShown', 'true');
              }
            }
          }
        }
      },
  
      seeTest() {
        console.log("clicando...")
        this.quizCompleted = false;
        this.selectedMode = 'Tutor';
        this.dialog = false; 
      },
  
      // Method to check if the option is the correct answer
    isCorrectOption(option) {
      if (!option || !this.currentQuestion.questionAnswer) return false;
      // O .trim() remove o \n e espaços do início e fim antes de comparar
      return option.trim() === this.currentQuestion.questionAnswer.trim();
    },

    // Method to check if the option is the selected wrong answer
    isWrongOption(option) {
      if (!option || !this.currentAnswer || !this.currentQuestion.questionAnswer) return false;
      
      // Compara se é a opção selecionada E se é diferente do gabarito (usando trim em tudo)
      return option.trim() === this.currentAnswer.trim() && 
             option.trim() !== this.currentQuestion.questionAnswer.trim();
    },
      calculateProgressPercentage() {
         return ((this.currentQuestionIndex + 1) / this.questions.length) * 100;
      },
      
      goToPreviousQuestion() {
        if (this.currentQuestionIndex > 0) {
          this.currentQuestionIndex--;
          this.currentQuestion = this.questions[this.currentQuestionIndex];
          this.currentAnswer = this.answers[this.currentQuestionIndex] || null; // Recupera a resposta já confirmada, se existir
          this.questionLocked = this.currentAnswer !== null;
        }
      },
  
      formatHTMLContent(text) {
        if (!text) return '';
        let cleanText = String(text);
        const hasHTML = /<[a-z][\s\S]*>/i.test(cleanText);
        if (!hasHTML) {
          cleanText = cleanText.replace(/\n/g, '<br>');
        }
        return cleanText;
      },
  
      validateNumberOfQuestions(value) {
        return value <= 90 || 'Número máximo de questões é 90';
      },

      confirmQuestion() {
        if (this.currentAnswer !== null) {
          this.completedQuestionIds.push(this.currentQuestion.questionId);

          const currentTheme = this.currentQuestion.questionTheme;
          if (!this.themeStats[currentTheme]) {
            this.themeStats[currentTheme] = {
              totalQuestions: 0,
              correctCount: 0,
              incorrectCount: 0,
            };
          }

          this.themeStats[currentTheme].totalQuestions++;
          if (this.isCorrectOption(this.currentAnswer)) {
            this.themeStats[currentTheme].correctCount++;
          } else {
            this.themeStats[currentTheme].incorrectCount++;
          }

          this.answers.splice(this.currentQuestionIndex, 1, this.currentAnswer);
          this.questionLocked = true;
          if (this.selectedMode === 'Tutor') {
            this.showCommentDrawer = true;
          }

          // Auto-save a cada 5 questões
          const notSentIds = this.completedQuestionIds.filter(
            id => !this.sentQuestionIds.includes(id)
          );
          if (notSentIds.length > 0 && this.completedQuestionIds.length % 5 === 0) {
            // Separa IDs corretos e incorretos
            const correctIds = [];
            const wrongIds = [];
            let totalRight = 0;
            let totalWrong = 0;

            this.completedQuestionIds.forEach(id => {
              const idx = this.questions.findIndex(q => q.questionId === id);
              if (idx !== -1) {
                const answer = this.answers[idx];
                const correct = this.questions[idx].questionAnswer;
                if (answer && correct && answer.trim() === correct.trim()) {
                  totalRight++;
                  correctIds.push(id);
                } else {
                  totalWrong++;
                  wrongIds.push(id);
                }
              }
            });

            // Estatísticas por tema apenas para o lote atual
            const themeStatsMap = {};
            let lastTotalRight = 0;
            let lastTotalWrong = 0;
            const lastCorrectIds = [];
            const lastWrongIds = [];

            notSentIds.forEach(id => {
              const idx = this.questions.findIndex(q => q.questionId === id);
              if (idx !== -1) {
                const theme = this.questions[idx].questionTheme;
                if (!themeStatsMap[theme]) {
                  themeStatsMap[theme] = { theme, totalQuestions: 0, correctCount: 0, incorrectCount: 0 };
                }
                themeStatsMap[theme].totalQuestions++;
                const answer = this.answers[idx];
                const correct = this.questions[idx].questionAnswer;
                if (answer === correct) {
                  themeStatsMap[theme].correctCount++;
                  lastTotalRight++;
                  lastCorrectIds.push(id);
                } else {
                  themeStatsMap[theme].incorrectCount++;
                  lastTotalWrong++;
                  lastWrongIds.push(id);
                }
              }
            });

            const myAnswers = notSentIds.map(id => {
              const idx = this.questions.findIndex(q => q.questionId === id);
              let optionLetter = null;
              if (idx !== -1) {
                const userAnswer = this.answers[idx];
                const optionIndex = this.questions[idx].questionOptions.indexOf(userAnswer);
                if (optionIndex !== -1) {
                  optionLetter = String.fromCharCode(97 + optionIndex);
                }
              }
              return {
                id: id,
                selectedOption: optionLetter
              };
            });
            const myAnswersJson = JSON.stringify(myAnswers);

            const themeStatsArray = Object.values(themeStatsMap);
            const themeStatsJson = JSON.stringify(themeStatsArray);
            const questionIdsJson = JSON.stringify(notSentIds);
            const questionIdsCorrectJson = JSON.stringify(lastCorrectIds);
            const questionIdsWrongJson = JSON.stringify(lastWrongIds);

            const postData = {
              lastTotalQuestions: notSentIds.length,
              lastQuestions: this.completedQuestionIds.length, // TOTAL de questões
              lastRight: totalRight, // TOTAL de acertos
              lastWrong: totalWrong, // TOTAL de erros
              lastTotalRight,        // Acertos do lote atual
              lastTotalWrong,        // Erros do lote atual
              themeStats: themeStatsJson, // Por lote
              questionIds: questionIdsJson, // Por lote
              questionIdsCorrect: questionIdsCorrectJson,
              questionIdsWrong: questionIdsWrongJson,
              myAnswers: myAnswersJson,
            };

            this.$store.dispatch('postItems', postData)
              .then(() => {
                this.sentQuestionIds.push(...notSentIds);
                console.log("Auto-save de 5 questões realizado.");
              })
              .catch((error) => {
                console.error("Erro ao auto-salvar:", error);
              });
          }
        }
      },
  
      nextQuestion() {
        if (this.currentAnswer !== null) {
          if (this.currentQuestionIndex < this.questions.length - 1) {
            this.currentQuestionIndex++;
            this.currentQuestion = null; // Força a remoção do componente
            this.$nextTick(() => {
              this.currentQuestion = { ...this.questions[this.currentQuestionIndex] }; // Cópia reativa
              this.currentAnswer = this.answers[this.currentQuestionIndex] || null; // Recupera a resposta já confirmada, se existir
              this.questionLocked = this.currentAnswer !== null; // Bloqueia a questão se já houver uma resposta
            });
          } else {
            this.quizCompleted = true;
            this.dialog = true;
          }
        }
      },
      resetTest() {
        this.$store.dispatch('saveProfile', { totalsincecsat: this.totalAnsweredQuestions });

        console.log("IDs das questões realizadas:", this.completedQuestionIds);

        this.resetting = true;
        this.quizStarted = false;

        const notSentIds = this.completedQuestionIds.filter(
          id => !this.sentQuestionIds.includes(id)
        );

        // Separa IDs corretos e incorretos para TODAS as questões
        const allCorrectIds = [];
        const allWrongIds = [];
        let totalRight = 0;
        let totalWrong = 0;

        this.completedQuestionIds.forEach(id => {
          const idx = this.questions.findIndex(q => q.questionId === id);
          if (idx !== -1) {
            const answer = this.answers[idx];
            const correct = this.questions[idx].questionAnswer;
            if (answer && correct && answer.trim() === correct.trim()) {
              totalRight++;
              allCorrectIds.push(id);
            } else {
              totalWrong++;
              allWrongIds.push(id);
            }
          }
        });

        // Estatísticas por tema apenas para o lote final
        const themeStatsMap = {};
        let lastTotalRight = 0;
        let lastTotalWrong = 0;
        const lastCorrectIds = [];
        const lastWrongIds = [];

        notSentIds.forEach(id => {
          const idx = this.questions.findIndex(q => q.questionId === id);
          if (idx !== -1) {
            const theme = this.questions[idx].questionTheme;
            if (!themeStatsMap[theme]) {
              themeStatsMap[theme] = { theme, totalQuestions: 0, correctCount: 0, incorrectCount: 0 };
            }
            themeStatsMap[theme].totalQuestions++;
            const answer = this.answers[idx];
            const correct = this.questions[idx].questionAnswer;
            if (answer === correct) {
              themeStatsMap[theme].correctCount++;
              lastTotalRight++;
              lastCorrectIds.push(id);
            } else {
              themeStatsMap[theme].incorrectCount++;
              lastTotalWrong++;
              lastWrongIds.push(id);
            }
          }
        });

        const myAnswers = notSentIds.map(id => {
          const idx = this.questions.findIndex(q => q.questionId === id);
          let optionLetter = null;
          if (idx !== -1) {
            const userAnswer = this.answers[idx];
            const optionIndex = this.questions[idx].questionOptions.indexOf(userAnswer);
            if (optionIndex !== -1) {
              optionLetter = String.fromCharCode(97 + optionIndex);
            }
          }
          return {
            id: id,
            selectedOption: optionLetter
          };
        });
        const myAnswersJson = JSON.stringify(myAnswers);

        const themeStatsArray = Object.values(themeStatsMap);
        const themeStatsJson = JSON.stringify(themeStatsArray);
        const questionIdsJson = JSON.stringify(notSentIds);
        const questionIdsCorrectJson = JSON.stringify(lastCorrectIds);
        const questionIdsWrongJson = JSON.stringify(lastWrongIds);

        const postData = {
          lastTotalQuestions: notSentIds.length,
          lastQuestions: this.completedQuestionIds.length,
          lastRight: totalRight,
          lastWrong: totalWrong,
          lastTotalRight,
          lastTotalWrong,
          themeStats: themeStatsJson,
          questionIds: questionIdsJson,
          questionIdsCorrect: questionIdsCorrectJson,
          questionIdsWrong: questionIdsWrongJson,
          myAnswers: myAnswersJson,
        };

        this.$store.dispatch('postItems', postData)
          .then(() => {
            this.sentQuestionIds.push(...notSentIds);
            console.log("Submission successful. Reloading...");
            setTimeout(() => {
              this.$router.push('/webapp/QuestionsResults');
              this.resetting = false;
            }, 5500);
          })
          .catch((error) => {
            console.error("Error submitting data:", error);
          });

        // Reset quiz data (excluding window reload)
        this.currentQuestionIndex = 0;
        this.currentQuestion = this.questions[0];
        this.currentAnswer = null;
        this.quizCompleted = false;
        this.answers = new Array(this.quizData.items.length);
        this.dialog = false;
        this.quizstart = false;
      }    
    }}
</script>


<style>
  /* CSS */
  .green-outline {
    -webkit-text-stroke: 0.5px green; /* Green outline for correct options */
    text-stroke: 1px green;
    color: transparent;
  }
  
  .red-outline {
    -webkit-text-stroke: 0.5px red; /* Red outline for wrong options */
    text-stroke: 1px red;
    color: transparent;
  }
  
  .loading-text {
    margin-top: 15px;
    font-weight: bold;
    font-size: 18px;
  }
  .question-card {
    background-color: #f5f5f5;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    padding: 20px;
  }
  
  .question-container {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
  }
  
  .image-container {
    margin-left: 20px;
    margin-top: 10px;
    text-align: center;
  }
  
  .question-image {
    max-width: 60%;
    height: auto;
    display: block;
  }
  
  .question-text {
    flex: 1;
    margin-bottom: 10px;
  }
  
  .v-btn {
    margin-top: 10px;
  }
  
  .text-justify {
    text-align: justify;
  }
  
  .justify-end {
    justify-content: flex-end;
  }

  /* Estilos globais para o HTML vindo do banco de dados */
  .html-content {
    line-height: 1.6;
    color: #333;
  }
  .html-content table {
    width: 100%;
    border-collapse: collapse;
    margin: 16px 0;
  }
  .html-content th, .html-content td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    text-align: left;
  }
  .html-content th {
    background-color: #f5f5f5;
    font-weight: 600;
  }
  .html-content ul, .html-content ol {
    margin-top: 8px;
    margin-bottom: 16px;
    padding-left: 24px;
  }
  .html-content li {
    margin-bottom: 6px;
  }
  .html-content p {
    margin-bottom: 14px;
  }
  .html-content blockquote {
    border-left: 4px solid #315fd8;
    padding-left: 16px;
    color: #555;
    background-color: #f9f9f9;
    padding: 12px 16px;
    border-radius: 4px;
    margin: 16px 0;
  }
  .html-content .perola {
    background-color: #fff3cd;
    border-left: 5px solid #ffc107;
    padding: 16px;
    margin: 16px 0;
    border-radius: 4px;
    color: #856404;
  }
  </style>